var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content add-warehouse-charge-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Warehouse.NewWarehouseFee"),
        width: "1000px",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "section", staticStyle: { width: "100%" } },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "100%" },
              attrs: { "label-width": "81px" }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.ChargeItem") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              "default-value": _vm.charge.chargeItemId,
                              "tag-value": "itemId",
                              "tag-name": "zhName",
                              clearable: ""
                            },
                            on: { parentCallBack: _vm.changeChargeItem }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ReceivableType") }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.charge.receivable,
                                callback: function($$v) {
                                  _vm.$set(_vm.charge, "receivable", $$v)
                                },
                                expression: "charge.receivable"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.receivable")))
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.payable")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Currency") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              clearable: false,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              "default-value": _vm.charge.currency
                            },
                            on: {
                              parentCallBack: function(p) {
                                return (_vm.charge.currency = p.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Unit") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.local_cache_ChargeMeasure,
                              filterable: "",
                              clearable: false,
                              "tag-name": _vm.language,
                              "default-value": _vm.charge.measure
                            },
                            on: {
                              parentCallBack: function(p) {
                                return (_vm.charge.measure = p.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.jobList,
              "show-side-bar": false
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveHandler } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Save")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "default" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }